"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var next_intl_1 = require("next-intl");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var public_api_1 = require("@l2p/public-api");
var apps_shared_1 = require("@l2p/apps-shared");
var Timer_1 = __importDefault(require("./Timer"));
var ui_components_1 = require("@l2p/ui-components");
var BonusConditions_1 = __importDefault(require("../BonusConditions"));
var BonusConditionsContent_1 = __importDefault(require("../BonusConditionsContent"));
var LimitedOfferWithBackground = function () {
    var _a, _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var promos = (0, swr_hooks_1.usePromotionsByTag)(swr_hooks_1.BonusTag.SPECIAL_OFFER).promotions;
    var bonusesForUser = (0, swr_hooks_1.useBonusesByType)(public_api_1.BonusType.Deposit).data;
    var _c = (0, react_1.useState)(false), isOpenModal = _c[0], setIsOpenModal = _c[1];
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var bonusToShow = (0, react_1.useMemo)(function () {
        if (bonusesForUser && (bonusesForUser === null || bonusesForUser === void 0 ? void 0 : bonusesForUser.length) > 0)
            return bonusesForUser === null || bonusesForUser === void 0 ? void 0 : bonusesForUser.find(function (bonus) { var _a; return (_a = bonus.slug) === null || _a === void 0 ? void 0 : _a.includes(swr_hooks_1.BonusTag.SPECIAL_OFFER); });
        return promos === null || promos === void 0 ? void 0 : promos[0];
    }, [promos, bonusesForUser]);
    if (!bonusToShow)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('limitedTimeOffer')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.info), onClick: function () { return setIsOpenModal(true); } },
                    react_1.default.createElement("img", { src: "/img/icons/infoRound.svg", alt: "info" })),
                react_1.default.createElement(Timer_1.default, null),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusAndActionContainer },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus }, translateLocale(bonusToShow === null || bonusToShow === void 0 ? void 0 : bonusToShow.title)),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", width: "100%", maxWidth: "320px", height: "56px", onClick: isAuth ? openDeposit : openSignUp }, t('getBonus')))))),
        isOpenModal && (react_1.default.createElement(BonusConditions_1.default, { onClose: function () { return setIsOpenModal(false); }, promoCode: (_a = bonusToShow === null || bonusToShow === void 0 ? void 0 : bonusToShow['promoCodes']) === null || _a === void 0 ? void 0 : _a[0] },
            react_1.default.createElement(BonusConditionsContent_1.default, { name: bonusToShow === null || bonusToShow === void 0 ? void 0 : bonusToShow.title, bonusConditions: translateLocale((_b = bonusToShow === null || bonusToShow === void 0 ? void 0 : bonusToShow.descriptions) === null || _b === void 0 ? void 0 : _b.long, {
                    ignoreReplaceNextLine: true,
                }) })))));
};
exports.default = LimitedOfferWithBackground;
